import { FC } from 'react'
import { useT } from '../../../../../_metronic/i18n/Metronici18n'
import { SituacaoModelo, SituacaoProtocolo } from '../core/_models'

const CHAVES_PROTOCOLO: Record<SituacaoProtocolo, [string, string]> = {
  RASCUNHO: ['protocolos_triagem.rascunho', 'Rascunho'],
  VIGENTE: ['protocolos_triagem.vigente', 'Vigente'],
  SUBSTITUIDO: ['protocolos_triagem.substituido', 'Substituído'],
}

const CHAVES_MODELO: Record<SituacaoModelo, [string, string]> = {
  RASCUNHO: ['protocolos_triagem.modelo_plataforma.situacao.R', 'Rascunho'],
  PUBLICADA: ['protocolos_triagem.modelo_plataforma.situacao.P', 'Publicada'],
  SUBSTITUIDA: ['protocolos_triagem.modelo_plataforma.situacao.S', 'Substituída'],
}

type Props = {
  situacao?: SituacaoProtocolo | SituacaoModelo | null
  escopo?: 'empresa' | 'modelo'
}

/**
 * Situação da versão — neutro/violeta da marca, <b>nunca</b> cor de risco: risco é semântica
 * clínica e não pode ser confundido com o estado do documento.
 */
export const SituacaoProtocoloBadge: FC<Props> = ({ situacao, escopo = 'empresa' }) => {
  const { t } = useT()
  if (!situacao) {
    return <span>—</span>
  }
  const chave =
    escopo === 'modelo'
      ? CHAVES_MODELO[situacao as SituacaoModelo]
      : CHAVES_PROTOCOLO[situacao as SituacaoProtocolo]
  const rotulo = chave ? t(chave[0], undefined, chave[1]) : situacao
  const emDestaque = situacao === 'VIGENTE' || situacao === 'PUBLICADA'

  return (
    <span
      className='badge rounded-pill px-3 py-2'
      // Tokens do tema (`_variables.custom.scss`), que têm variante própria no modo escuro.
      style={
        emDestaque
          ? { backgroundColor: 'var(--brand-primary-dark)', color: '#FFFFFF' }
          : {
              backgroundColor: 'var(--bs-primary-light)',
              color: 'var(--bs-primary-text-emphasis)',
              border: '1px solid var(--bs-border-color)',
            }
      }
    >
      {rotulo}
    </span>
  )
}
